import { Controller } from "@hotwired/stimulus"
import posthog from 'posthog-js';

// Connects to data-controller="sign-out"
export default class extends Controller {
  connect() {
    posthog.reset();
  }
}
